import { z } from 'zod';

export const CreateProjectResponseSchema = z.object({
  project: z.object({
    metaSiteId: z.string(),
  }),
});
